
import { FaFacebookF } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { AiFillYoutube } from "react-icons/ai";
import IconUI from "./ui/icon_ui";
import logoSecum from "../assets/images/logoSecum.png";
import Sello from "../assets/images/Sello.png";
import LogoAniversario from "../assets/images/mich-mejor.png";

const FooterComponet = () => {
  return (
    <>
      <div
        id="footer"
        className="shadow-sm bg-white footer p-4 margin-on-search "
      >
        <div className="container">
          <div className="d-md-flex d-none  align-items-center justify-content-center">
            <div>
              <img
                className="logoAniversario mx-5"
                src={LogoAniversario}
                alt="logo"
              />
              <img className="logoGris" src={logoSecum} alt="logo" />
              <img className="logoSello ms-5" src={Sello} alt="logo" />
            </div>
            <div>
              <div className="redes text-center d-flex justify-content-center">
           
                <a
                  href="https://www.facebook.com/SECULTMICH"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-2 icon_btn pointer"
                >
                  <IconUI size={"22px"} color="#800040">
                    <FaFacebookF />
                  </IconUI>
                </a>

                <a
                  href="https://www.youtube.com/c/CulturaMichoac%C3%A1n"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-2 icon_btn pointer"
                >
                  <IconUI size={"25px"} color="#800040">
                    <AiFillYoutube />
                  </IconUI>
                </a>

                <a
                  href="https://twitter.com/SCultura_Mich"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-2 icon_btn pointer"
                >
                  <IconUI size={"22px"} color="#800040">
                    <BsTwitter />
                  </IconUI>
                </a>
             
              </div>
              <div className="mt-1">
                <div className="text-center text-small text-morado">
                  Enlaces de comunicación
                </div>
              </div>
            </div>
          </div>
          <div className="d-md-none d-flex  flex-column align-items-center justify-content-center">
            <div className="d-flex aling-items-center">
              <img className="logoGris" src={logoSecum} alt="logo" />
              <img className="logoSello ms-5" src={Sello} alt="logo" />
            </div>
            <div className="mt-4">
              <div className="redes text-center d-flex justify-content-center">
      
                               <a
                  href="https://www.facebook.com/SECULTMICH"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-2 icon_btn pointer"
                >
                  <IconUI size={"22px"} color="#800040">
                    <FaFacebookF />
                  </IconUI>
                </a>

                <a
                  href="https://www.youtube.com/c/CulturaMichoac%C3%A1n"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-2 icon_btn pointer"
                >
                  <IconUI size={"25px"} color="#800040">
                    <AiFillYoutube />
                  </IconUI>
                </a>

                <a
                  href="https://twitter.com/SCultura_Mich"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-2 icon_btn pointer"
                >
                  <IconUI size={"22px"} color="#800040">
                    <BsTwitter />
                  </IconUI>
                </a>

              </div>
              <div className="mt-1">
                <div className="text-center text-small text-morado">
                  Enlaces de comunicación 
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterComponet;
